import { save } from "../../app/store.js";
import { log } from "../../services/audit.js";
import { render } from "../../app/shell.js";
import { S, ui } from "../../app/store.js";
import { V } from "../../app/pages.js";
import { can, emp } from "../../services/access.js";
import { today, fmtD } from "../../domain/dates.js";
import { esc, peso } from "../../domain/format.js";
import { panel, csvBtn } from "../../components/ui.js";
import {
  monthlyStatutory,
  statutoryChecklist,
  STATUTORY_SOURCES,
} from "../../domain/statutory.js";
V.statutory = () => {
  const month = (ui.statutoryDate || today()).slice(0, 7),
    { runs, totals, agencies } = monthlyStatutory(S, month),
    checks = statutoryChecklist(S),
    year = month.slice(0, 4),
    annual = S.runs.filter(
      (r) => r.pay.startsWith(year) && r.status !== "DRAFT",
    );
  return `<div class="form"><label>Reporting month<input id="statutory-date" type="date" value="${esc(ui.statutoryDate || today())}"></label></div><p class="note">Government contributions are consolidated per employee across all sites and projects. This register prepares your figures; agency filing and payment remain separate actions.</p>
 ${panel("Monthly statutory register", `${month} · ${runs.length} approved / released payroll runs`, csvBtn("t-statutory"), `<div class="tbl"><table id="t-statutory"><thead><tr><th>Agency</th><th class="n">Employee deductions</th><th class="n">Employer share</th><th class="n">Total payable</th><th>Ledger account</th></tr></thead><tbody>${agencies.map((r) => `<tr><td>${esc(r.agency)}</td><td class="n">${peso(r.employee)}</td><td class="n">${peso(r.employer)}</td><td class="n">${peso(r.employee + r.employer)}</td><td>${r.account}</td></tr>`).join("")}</tbody></table></div>`)}
 ${panel(
   "13th-month benefit register",
   `${year} · Accrued from basic earnings, excluding overtime and premiums`,
   csvBtn("t-thirteenth"),
   `<div class="tbl"><table id="t-thirteenth"><thead><tr><th>Employee</th><th class="n">Basic earnings YTD</th><th class="n">Accrued 13th-month pay</th></tr></thead><tbody>${S.employees
     .map((e) => {
       const basic = annual
         .flatMap((r) => r.lines)
         .filter((l) => l.emp === e.id)
         .reduce((a, l) => a + (l.base13 || l.gross || 0), 0);
       return `<tr><td>${esc(e.name)}</td><td class="n">${peso(basic)}</td><td class="n">${peso(Math.round(basic / 12))}</td></tr>`;
     })
     .join(
       "",
     )}</tbody></table></div><p class="small muted">Historical payroll imports retain their original entries. New payroll approvals post the 13th-month accrual to account 2140; the benefit register also displays the accrual basis for historical lines.</p>`,
 )}
 ${can("dep.manage") || can("bir.file") ? employerRegistrationForm() : ""}
 ${panel("Enrollment & employer requirements", "Complete the missing IDs before preparing government remittance files.", can("hr.salary") ? '<button data-go="people">Update personnel IDs</button>' : "", `<p class="small muted">Employer fields missing: ${esc(checks.employer.join(", ") || "None")}</p><div class="tbl"><table><thead><tr><th>Employee</th><th>Missing registration IDs</th></tr></thead><tbody>${checks.employees.map((r) => `<tr><td>${esc(emp(r.emp)?.name)}</td><td>${esc(r.missing.join(", "))}</td></tr>`).join("") || '<tr><td colspan="2">All employee IDs are complete.</td></tr>'}</tbody></table></div>`)}
 ${panel("Rule sources & effective dates", "Official references checked on 22 October 2026. New regional orders and annual filing schedules need an effective-date update.", "", `<div class="inbox">${STATUTORY_SOURCES.map((r) => `<div><div><strong>${esc(r.agency)}</strong><div class="small muted">Effective ${fmtD(r.effective)} · ${esc(r.detail)}</div></div><a href="${r.url}" target="_blank" rel="noopener noreferrer">Official source ↗</a></div>`).join("")}</div>`)}
 `;
};
export function employerRegistrationForm() {
  return `<form id="employer-registration" class="work-log-form"><h3>Employer registration numbers</h3><div class="form">${[
    ["sssEmployer", "SSS employer number"],
    ["philhealthEmployer", "PhilHealth employer number (PEN)"],
    ["pagibigEmployer", "Pag-IBIG employer ID"],
  ]
    .map(
      ([key, label]) =>
        `<label>${label}<input name="${key}" value="${esc(S.company[key] || "")}" maxlength="40" autocomplete="off"></label>`,
    )
    .join(
      "",
    )}</div><button class="pri" type="submit">Save employer registrations</button></form>`;
}

export function installStatutoryEvents() {
  document.addEventListener("submit", (event) => {
    if (event.target.id !== "employer-registration") return;
    event.preventDefault();
    if (!can("dep.manage") && !can("bir.file")) return;
    const fields = Object.fromEntries(new FormData(event.target));
    for (const key of ["sssEmployer", "philhealthEmployer", "pagibigEmployer"])
      S.company[key] = String(fields[key] || "").trim();
    log(
      "Updated employer registrations",
      "SSS, PhilHealth and Pag-IBIG employer numbers",
    );
    save();
    render();
  });
}
